import {useForm} from "react-hook-form";
import {ONE_TIME} from "./Constants/PaymentTypes";
import {useFetchMethods} from "./Hooks/useFetchMethods";
import {useState} from "react";
import PaymentMethodSwitch from "./Components/PaymentMethodSwitch";
import {postPaymentRequest} from "./Functions/ServerFunctions";
import i18n from "./i18n";
import {useFormIsValid} from "./Hooks/useFormIsValid";

import s from './App.module.scss';
import block from "bem-css-modules";
import {useTranslation} from "react-i18next";
import ProgressBar from "./Components/ProgressBar/ProgressBar";
import {useFormatFee} from "./Hooks/useFormatFee";
import {useGetPayment} from "./Hooks/useGetPayment";

const b = block(s);

// eslint-disable-next-line
const initI18n = i18n;

const el = document.getElementById('payments-form');

function App() {
    const {t} = useTranslation('common');
    const [paymentType] = useState(ONE_TIME);

    const paymentId = el.getAttribute("data-payment") || 0;

    const {control, handleSubmit, watch, formState: {isValid}} = useForm({
            defaultValues: {
                paymentType: ONE_TIME,
                payment_id: paymentId
            },
            mode: 'onChange',
        }
    );
    const {submitEnabled, setSubmitEnabled} = useFormIsValid(isValid);
    const [error, setError] = useState('');

    const watchPaymentMethod = watch("paymentMethod", 0);

    const {loading: loadingPayment, payment: {amount, paid}} = useGetPayment(paymentId);

    const loading = useFetchMethods();

    const {feeFormatted, totalAmountFormatted} = useFormatFee(watchPaymentMethod, amount);

    const onSubmit = data => {
        setSubmitEnabled(false);
        postPaymentRequest(data)
            .then(response => {
                if (response.url) {
                    window.open(response.url, "_self")
                } else {
                    setError(response.error)
                    setSubmitEnabled(true);
                }
            })
            .catch(error => setError(error))
    }

    if (paid === 1) {
        return <div className={b()}><h3 className={b('error')}>{t('errors.is_already_paid')}</h3></div>
    }

    if (loading || loadingPayment) {
        return <div className={b()}><ProgressBar size={90}/></div>
    }

    return (
        <div className={b()}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <input type='hidden' name='payment_id'/>
                {!loadingPayment && <div>{t('participation.price')} <span
                    className={b("price-highlight")}>{amount}€.</span></div>}
                <div className={b('fees')}>
                    {feeFormatted && <span>{t('fee')}: {feeFormatted}.</span>}
                    {totalAmountFormatted && <span>{t('total')}: {totalAmountFormatted}.</span>}
                </div>
                <PaymentMethodSwitch control={control} name='paymentMethod' paymentType={paymentType}/>
                <h3 className={b('error')}>{error ? t('errors.'+error) : ''}</h3>
                <div className={b('buttons')}>
                    {!submitEnabled && <ProgressBar size={40} trackWidth={4} indicatorWidth={4}/>}
                    {submitEnabled && <input type="submit" disabled={!submitEnabled}/>}
                </div>
            </form>
        </div>
    );
}

export default App;
